import { apiClient, WEBSITE_CASE_FILES } from '../../../shared/api';

export const fetchCaseFiles = async () => {
  const response = await apiClient.get(WEBSITE_CASE_FILES());

  return response.data;
};
